<template>
  <MessageBanner type="reminder" inline="bottom" condensed class="px-6 py-3" data-testid="top-products-ranking-countdown">
    <i18n-t v-if="daysLeft > 0" keypath="ProductTop100Ranking.countdown.motivation" tag="span" scope="global">
      <template #days>
        <strong data-testid="top-products-ranking-countdown-days">{{ t('ProductTop100Ranking.countdown.days', daysLeft) }}</strong>
      </template>
    </i18n-t>
    <template v-else>
      {{ t('ProductTop100Ranking.countdown.lastDay') }}
    </template>
  </MessageBanner>
</template>

<script setup lang="ts">
import { MessageBanner } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { daysUntilCollectionDeadline } from './collectionDeadline'

const props = defineProps<{
  now?: Date
}>()

const { t } = useI18n()

const daysLeft = computed(() => daysUntilCollectionDeadline(props.now ?? new Date()))
</script>
